export default {
	home: {
		// 游戏分类标题
		afunOriginals: "Originais AFun",
		slots: "Slots",
		liveCasino: "Cassino ao Vivo",
		casualGames: "Jogos Casuais",
		newReleases: "Novos Lançamentos",

		// 三大入口
		casinoTitle: "Cassino",
		casinoDesc: "Aproveite jogos de cassino com milhares de slots, dealers ao vivo e jogos de mesa",
		goToCasino: "Ir para Cassino",
		sportsTitle: "Esportes",
		sportsDesc: "Aposte em Futebol, Basquete, Tênis e mais esportes com as melhores odds",
		goToSports: "Ir para Esportes",
		liveTitle: "Ao Vivo",
		liveDesc: "Ação em tempo real com dealers ao vivo e experiência de jogo interativa",
		goToLive: "Ir para Ao Vivo",

		// Latest Bet & Race
		latestBetRace: "Últimas Apostas e Corrida",
		sports: "Esportes",
		latestBets: "Últimas Apostas",
		game: "Jogo",
		player: "Jogador",
		bet: "Aposta",
		multiplier: "Multiplicador",
		profit: "Lucro",

		// Top 10
		top10Games: "Top 10 Jogos",

		// VIP 卡片
		vipClub: "Clube VIP",
		details: "Detalhes",
		progressToVip: "{percent}% para VIP {level}",
		vipMax: "VIP MÁX",

		// VIP Details 弹窗
		vipDetailsTitle: "Nível VIP e Benefícios",
		vipColLevel: "Nível",
		vipColRequired: "Requisito",
		vipColLevelUpBonus: "Bônus de promoção",
		vipColDailyRakeback: "Rakeback diário",
		vipColWeeklyLossback: "Lossback semanal",
		vipColMonthlyRakeback: "Rakeback mensal",
		vipRequiredRecharge: "Depósito",
		vipRequiredBets: "Apostas",
		vip: "VIP",
		rewards: "Recompensas",
		affiliate: "Afiliado",
		promotion: "Promoção"
	},

	latestBetRace: {
		title: "Grande Prêmio do Ranking de Jogos",
		playerBetRank: "Apostas de Jogadores de Hoje",
		playerWinRank: "Vitórias de Jogadores de Hoje",
		gameBetRank: "Apostas de Jogos de Hoje",
		gameWinRank: "Retornos de Jogos de Hoje",
		player: "Jogador",
		game: "Jogo",
		bet: "Aposta",
		profit: "Vitória",
		ratio: "Taxa de Pagamento",
		totalBet: "Aposta Total",
		totalReturn: "Retorno Total",
		maxBet: "Aposta Máxima",
		gameRatio: "% de Retorno",
		noData: "Nenhum Dado Disponível",
	},

	GameClassify: {
		casinoTitle: "Cassino",
		casinoDesc: "Divirta-se com jogos de cassino dos melhores provedores",
		casinoBtn: "Ir para o Cassino",
		sportsTitle: "Esportes",
		sportsDesc: "Aposte em Futebol, Críquete, NFL, eSports e mais de 80 esportes",
		sportsBtn: "Ir para Esportes",
		liveTitle: "Ao Vivo",
		liveDesc: "Ação em tempo real com crupiês ao vivo",
		liveBtn: "Ir para Ao Vivo"
	}
}